/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import './aeration-connected-systems.scss';

/* eslint-disable import/no-unresolved, import/default */

import aerationConnectedSystemsTemplate from './aeration-connected-systems.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('agrolog.client.aerationConnectedSystems', [])
    .directive('agAerationConnectedSystems', AerationConnectedSystems)
    .name;

/*@ngInject*/
function AerationConnectedSystems() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            ctx: '='
        },
        controller: AerationConnectedSystemsController,
        controllerAs: 'vm',
        templateUrl: aerationConnectedSystemsTemplate
    };
}

/* eslint-disable angular/angularelement */

/*@ngInject*/
function AerationConnectedSystemsController($scope, $q, $translate, agTypes, aerationService, userService) {

    let vm = this;

    vm.agTypes = agTypes;

    vm.loading = false;

    vm.showData = userService.getAuthority() === 'TENANT_ADMIN' || userService.getAuthority() === 'CUSTOMER_USER';
    vm.aerationId = null;
    vm.aeration = null;

    vm.getConnectedSystems = getConnectedSystems;
    vm.getMapConnectedSystems = getMapConnectedSystems;

    $scope.$watch('vm.ctx', function() {
        if (vm.ctx) {
            vm.ctx.widgetActions = [];
            vm.ctx.hideTitlePanel = false;
            vm.ctx.assetBrowserWidgetType = agTypes.assetBrowserWidgetType.dashboard;

            vm.aerationId = null;
            if (vm.ctx.stateController) {
                vm.aerationId = vm.ctx.stateController.getStateParams().entityId;
            }
            loadAeration();
            $scope.$watch(function() {
                    return vm.ctx.stateController.getStateParams().entityId;
                },
                function (newAerationId, prevAerationId) {
                    if (newAerationId && !angular.equals(newAerationId, prevAerationId)) {
                        vm.aerationId = newAerationId;
                        loadAeration();
                    }
                }
            );

        }
    });

    $scope.$watch(function() { return vm.aeration ? (vm.aeration.label || vm.aeration.name) : null; }, function(title) {
        if (vm.showData && vm.ctx && title) {
            vm.ctx.widgetTitle = $translate.instant('ag.aeration.aeration-connected-systems') + ': ' + title;
        }
    });

    $scope.$on('$destroy', function() {
        reset();
    });

    function getConnectedSystems(fetchAlarmsSeverity) {
        if (vm.aerationId) {
            return aerationService.getAerationConnectedSystems(vm.aerationId, fetchAlarmsSeverity);
        } else {
            return $q.when([]);
        }
    }

    function getMapConnectedSystems(fetchAlarmsSeverity) {
        if (vm.aerationId) {
            return aerationService.getMapAerationConnectedSystems(vm.aerationId, fetchAlarmsSeverity);
        } else {
            return $q.when([]);
        }
    }

    function loadAeration() {
        vm.aeration = null;
        reset();
        if (vm.aerationId) {
            vm.loading = true;
            aerationService.getAeration(vm.aerationId).then(
                function success(aeration) {
                    vm.aeration = aeration;
                    vm.loading = false;
                },
                function fail() {
                    vm.loading = false;
                }
            );
        }
    }

    function reset() {
    }

}